export class User {
	userId: number;
  name: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  password: string;
  confirmPassword: string;
  fullName: string;
  phoneNumber: string;
  companyName: string;
  requestKey: string;
  title: string;
  mediaId: number;
  verified: boolean;
  verificationCode: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/signin-signup/classes/user.ts